var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documentation-raw",style:({ 'max-width': _vm.maxWidth ? _vm.maxWidth : '768px' })},[_c('div',{staticClass:"prismic-raw",domProps:{"innerHTML":_vm._s(_vm.textHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }